import styles from "./loglist.module.css";
import { Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from "@mui/material";
import ItemCard from "./ItemCard";
import TableRowCard from "./TableRowCard";

const LogList = ({ filteredData, totalCount, filterData, setFilterData }) => {

    return (<div className={`${styles.IncomeListUnderSec}`}>

        <div className={`${styles.ListCardDivSec}`}>
            {filteredData?.map(item => {
                return <ItemCard item={item} />
            })}
        </div>

        <TableContainer className={`${styles.TableDiv} CustomTableDiv`}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 400 }}>Name</TableCell>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 100 }}>Status</TableCell>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 150 }}>Audience</TableCell>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 150 }}>Analytics</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {filteredData?.map(item => {
                        return <TableRowCard item={item} />
                    })}
                </TableBody>
            </Table>
        </TableContainer>

        {filteredData.length > 0 && (<div className="Pagination TablePaginationNew List">
            <TablePagination
                count={totalCount}
                color="primary"
                page={filterData?.page}
                rowsPerPage={filterData?.perPage}
                onPageChange={(e, v) => {
                    setFilterData(prev => {
                        return { ...prev, page: v };
                    })
                }}
                rowsPerPageOptions={[
                    { label: "4", value: 4 },
                    { label: "8", value: 8 },
                    { label: "16", value: 16 },
                    { label: "All", value: -1 },
                ]}
                onRowsPerPageChange={(e) => {
                    setFilterData(prev => {
                        return { ...prev, page: 0, perPage: e.target.value };
                    })
                }}
                labelRowsPerPage={"Logs per Page:"}
            />
        </div>)}

        {filteredData.length === 0 && (<div className={`${styles.NoDataMain}`}>
            <div className={`${styles.NoDataIMG}`}>
                <img src="/static/img/no-prospect.png" alt="No Data" />
            </div>
            <p className={`${styles.NoDataText}`}>Let's get started!</p>
            <p className={`${styles.NoDataTextSub}`}>You don't have any logs saved.</p>
        </div>)}

    </div>)
}

export default LogList;